import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { AiFillContacts } from 'react-icons/ai';
import { BsFillChatSquareQuoteFill } from 'react-icons/bs';
import { FaHome } from 'react-icons/fa';
import { IoHome, IoLogIn, IoLogOut } from 'react-icons/io5';
import { MdInfo } from 'react-icons/md';
import { RiBook2Fill } from 'react-icons/ri';
import 'react-modern-drawer/dist/index.css';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { avatar } from '../../../../Constant';
import DrawerSkeleton from '../../../../Drawer';
import classes from './MobileHeader.module.css';
import { SendNextIcon } from '../../../../Assets/icons';
import { PersonIcon } from '../../../../Assets/icons';
import { PiUserListBold } from 'react-icons/pi';
import { MdOutlineLeaderboard } from 'react-icons/md';
import { MdOutlineSettings } from 'react-icons/md';
import { CalendarIcon } from '../../../../Assets/icons';
import { QueueIcon } from '../../../../Assets/icons';
import { TbLogout } from 'react-icons/tb';
import { HomeIcon } from '../../../../Assets/icons';
import clsx from 'clsx';
import { ShieldIcon } from '../../../../Assets/icons';
export const MobileHeader = ({
  customStyle,
  containerClass,
  isScroll,
  onLogout,
  setIsModalOpen,
  show,
  toggleDrawer = () => {}
}) => {
  const navigate = useNavigate();

  const { isLogin } = useSelector((state) => state?.authReducer);
  const [openLogin, setOpenLogin] = useState(false);

  // current page url path name
  const currentPage = window.location.pathname;

  const RenderListItem = ({ icon, text, customClass, path, href, onClick }) => {
    return (
      <div
        className={[classes.listItem, customClass].join(' ')}
        onClick={() => {
          if (typeof onClick == 'function') {
            onClick();
            return;
          }
          if (path.toLowerCase() == 'logout') {
            onLogout();
          } else if (path.toLowerCase() == 'login') {
            setOpenLogin(true);
          } else {
            navigate(path, { state: { href } });
          }
        }}>
        {icon}
        <span className={classes.listItemText}>{text}</span>
      </div>
    );
  };

  return (
    <>
      <style jsx>{`
        .mobile-drawer > div {
          padding-inline: 20px;
        }
        @media (max-width: 515px) {
          .mobile-drawer {
            width: 300px !important;
          }
        }
      `}</style>
      <div
        className={[classes.headerMainDiv, isScroll && classes.afterScroll].join(' ')}
        id={'navMobileHeader'}>
        <DrawerSkeleton
          size={300}
          show={show}
          setShow={toggleDrawer}
          direction="left"
          parentClass={'mobile-drawer'}
          className={classes.innerWrapper}>
          <div className={clsx(classes.drawerContainer, 'scrollbar1')}>
            <div className={classes.drawerUserSection}>
              <>
                <div className={classes.drawerImg}>
                  <img src={avatar} alt="user avatar" title="user" />
                </div>
                <div>
                  <div className={classes.content}>
                    <h3>Dr. Maha Ilyas</h3>
                    <p>Physician</p>
                  </div>
                </div>
              </>
            </div>
            <div className={classes.drawerList}>
              <>
                <RenderListItem
                  icon={<HomeIcon />}
                  text={'Home'}
                  customClass={currentPage == '/' && classes.activeItem}
                  path={'/'}
                />
                <RenderListItem
                  icon={<QueueIcon size={20} color="var(--white-color)" />}
                  text={'Queue'}
                  customClass={currentPage == '/about' && classes.activeItem}
                  path={'/dashboard'}
                />
                <RenderListItem
                  icon={<CalendarIcon size={20} color="var(--white-color)" />}
                  text={'Schedule'}
                  customClass={currentPage == '/about' && classes.activeItem}
                  path={'/dashboard'}
                />
                <RenderListItem
                  icon={<PiUserListBold size={20} color="var(--white-color)" />}
                  text={'Patients'}
                  customClass={currentPage == '/patient-list' && classes.activeItem}
                  path={'/patient-list'}
                />
                <RenderListItem
                  icon={<MdOutlineLeaderboard size={20} color="var(--white-color)" />}
                  text={'Statistics'}
                  customClass={currentPage == '/faq' && classes.activeItem}
                  path={'/faq'}
                />
                <RenderListItem
                  icon={<ShieldIcon />}
                  text={'Subscription'}
                  customClass={currentPage == '/contact' && classes.activeItem}
                  path={'/contact'}
                />

                {isLogin && (
                  <>
                    <RenderListItem
                      icon={<FaHome />}
                      text={'Settings'}
                      customClass={currentPage == '/dashboard' && classes.activeItem}
                      path={'/dashboard'}
                    />
                  </>
                )}

                {isLogin ? (
                  <>
                    <RenderListItem
                      icon={<TbLogout size={20} color="var(--white-color)" />}
                      text={'logout'}
                      path={'logout'}
                    />
                  </>
                ) : (
                  <>
                    <RenderListItem
                      icon={<IoLogIn />}
                      text={'Help'}
                      onClick={() => setIsModalOpen('login')}
                    />
                    <RenderListItem
                      icon={<IoLogIn />}
                      text={'Sign Up'}
                      onClick={() => setIsModalOpen('signup')}
                    />
                  </>
                )}
              </>
            </div>
          </div>
        </DrawerSkeleton>
      </div>
    </>
  );
};

MobileHeader.propTypes = {
  customStyle: PropTypes.object
};

MobileHeader.defaulProps = {};
